import React from 'react';

export interface CorazonIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const CorazonIcon: React.FC<CorazonIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g clip-path="url(#a)"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21.174 5.422a5.5 5.5 0 0 0-7.78 0l-1.06 1.06-1.06-1.06a5.501 5.501 0 1 0-7.78 7.78l8.84 8.84 8.84-8.84a5.5 5.5 0 0 0 0-7.78"/></g><defs><clipPath id="a"><path fill="currentColor" d="M.333.813h24v24h-24z"/></clipPath></defs>
    </svg>
  );
};

export default CorazonIcon;
